import { useEffect, useState } from "react";
import { fetchPublishedContent } from "./cms";

// Renders instantly with the baked-in default, then swaps in the live
// published content once fetched (stale-while-revalidate feel). If the fetch
// fails or the page isn't published yet, the default stays — so the page is
// always populated and never flashes empty.
export function useCmsContent<T>(slug: string, fallback: T): T {
  const [content, setContent] = useState<T>(fallback);
  useEffect(() => {
    let active = true;
    fetchPublishedContent<T>(slug).then((data) => {
      if (active && data) setContent(data);
    });
    return () => {
      active = false;
    };
  }, [slug]);
  return content;
}
